import React from "react";
import { Outlet } from "react-router-dom";

import PrivateHeader from "./Header/PrivateHeader";
import Sidebar from "./Sidebar";
import { BodyStyled, MainLayoutStyled, MainWrapperStyled } from "./styles";
import { ILayoutProps } from "./type";
import SocketProvider from "../Provider/SocketProvider";

export interface ILandingPageLayoutProps extends ILayoutProps {
  extraInfo?: any;
}

const PrivateLayout: React.FunctionComponent<ILandingPageLayoutProps> = ({
  children,
}) => {
  return (
    <MainLayoutStyled>
      <SocketProvider>
        <PrivateHeader />
        <BodyStyled>
          <Sidebar />
          <MainWrapperStyled>{children || <Outlet />}</MainWrapperStyled>
        </BodyStyled>
      </SocketProvider>
    </MainLayoutStyled>
  );
};

export default PrivateLayout;
